import CategoryAttributesComponent from "./CategoryAttributesComponent";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import Card from "../../Components/Cards/Card";
import "../../assets/css/pages/categories.css";
import axios from "axios";

const CategoryAttributes = () => {
  const params = useParams();
  const [categoryWithAttributes, setCategoryWithAttributes] = useState();
  const navigate = useNavigate();
  const {id} = useParams();
  const [attributeId, setAttributeId] = useState();

  useEffect(() => {
    axios.get('/attributes/showByCategory/' + params.id)
      .then(response => {
        setCategoryWithAttributes(response?.data?.category_attributes)
      })
  }, []);

  const triggerAttributesLoop = (attributeId) => {
    setAttributeId(attributeId);
    axios.get('/attributes/showByCategory/' + params.id)
      .then(response => {
        setCategoryWithAttributes(response?.data?.category_attributes)
      })
  }

  const updateAttributesShow = (show) => {
    axios.post('/attributes/update-show', {categoryId: id, show}).then(res => {
      setCategoryWithAttributes({
        ...categoryWithAttributes,
        attributes: categoryWithAttributes.attributes.map((item) => ({
          ...item,
          show: show
        }))
      })
    });
  }

  return (
    <Card title="Show Category Attributes" classes="category-attributes">
      <div className="row">
        <div className="col-12 mb-10">
          <h3 className="ls-1">
            <i className="fas fa-stream fs-4 mx-1 text-primary"></i> Category <i
            className="fas fa-angle-double-right text-primary"></i> {categoryWithAttributes?.name ? categoryWithAttributes?.name : "N/A"}
          </h3>
        </div>
        <div>
          <h5 className="ls-1 mb-10 mx-3 d-inline-block color-dar-grey">
            <i className="fas fa-list mr-3 fs-3 text-primary"></i>
            Attributes
          </h5>

          {categoryWithAttributes?.children.length === 0 &&
            (
              <button
                type="button"
                className="btn btn-primary float-right mb-5 ml-3"
                onClick={() => {
                  navigate("/categories/" + id + "/attributes/create")
                }}
              >
                <i className="fas fa-plus mr-3 fs-3"></i>
                Add Attribute
              </button>
            )
          }

          <button
            type="button"
            className="btn btn-danger float-right mb-5 ml-3"
            onClick={() => updateAttributesShow(false)}
          >
            <i className="fa fa-ban fs-3 mr-3"></i>
            Hide all
          </button>

          <button
            type="button"
            className="btn btn-success float-right mb-5 ml-3"
            onClick={() => updateAttributesShow(true)}
          >
            <i className="fa fa-check fs-3 mr-3"></i>
            Show all
          </button>
        </div>


        <div className="attributes">
          <div className="col-12 mb-5">
            <div className="row">
              {categoryWithAttributes &&
                (categoryWithAttributes?.attributes.map((attribute, index) =>
                  <CategoryAttributesComponent
                    indexa={index}
                    attribute={attribute}
                    triggerAttributesLoop={triggerAttributesLoop}
                    categoryWithAttributes={categoryWithAttributes}
                    setCategoryWithAttributes={setCategoryWithAttributes}
                  />
                ))
              }
              {
                categoryWithAttributes?.attributes.length == 0 &&
                (
                  <div className="fs-4">
                    <i className="fas fa-exclamation-triangle mx-3 fs-4 text-warning"></i>
                    There is no attributes for this category!
                  </div>
                )
              }
              {
                categoryWithAttributes?.children.length !== 0 &&
                (
                  <div className="fs-4 mt-5">
                    <i className="fas fa-exclamation-triangle mx-3 fs-4 text-danger"></i>
                    This is the last child category! You cannot add attributes!
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default CategoryAttributes;